import React from 'react';
import PropTypes from 'prop-types';
import CollapsibleFormSection from "./CollapsibleFormSection";
import {updateHost, updateVisit, updateVisitor} from "../../../Redux/BookingFormActions";
import Tooltip from "@mui/material/Tooltip";
import {useDispatch} from "react-redux";

const CollapsibleVisitorSummary = (props) => {
    let dispatch = useDispatch();

    const visitorIsSignedIn = () => {
        return (props.visitor.signed_in_at && !props.visitor.signed_out_at);
    }

    const handleChangeCollapsed = (isCollapsed) => {
        if (isCollapsed && props.shouldDeleteIfEmptyOnCollapse) {
            // Delete instead of collapsing if the flag is set on component and the host/user has not been set
            if (!props.visitor.name) {
                props.onDelete(null, props.index);
                return;
            }
        }
        if (!props.onCollapse) {
            dispatch(updateVisitor('_isCollapsed', isCollapsed, props.index));
        } else {
            props.onCollapse(props.index, isCollapsed);
        }
    }

    return <CollapsibleFormSection
        index={props.index}
        name={props.visitor.name}
        details={[
            <Tooltip title={(props.visitor.email && props.visitor.email.length) ? props.visitor.email : 'No email specified'}>
                <i className="fa fa-envelope"
                   style={{opacity: (props.visitor.email) ? 1.0 : 0.15}}
                />
            </Tooltip>,
            (visitorIsSignedIn())
                ? <div style={{display: 'inlineBlock', textAlign: 'right', width: '100%', color: 'red'}}>
                    Visitor is signed in
                </div>
                : null,
        ]}
        isCollapsed={props.visitor._isCollapsed && !props.preventCollapse}
        onChangeCollapsed={handleChangeCollapsed}
        onDelete={(visitorIsSignedIn()) ? null : props.onDelete}
        hideButtons={props.hideButtons}
        className={props.className}
    >
        {props.children}
    </CollapsibleFormSection>
}

CollapsibleVisitorSummary.propTypes = {
    index: PropTypes.any,
    visitor: PropTypes.object,
    onDelete: PropTypes.func,
    hideButtons: PropTypes.bool,
    preventCollapse: PropTypes.bool,
    shouldDeleteIfEmptyOnCollapse: PropTypes.bool,
    className: PropTypes.string,
}

CollapsibleVisitorSummary.defaultProps = {
    hideButtons: false,
    preventCollapse: false,
}

export default CollapsibleVisitorSummary;
